import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect (): void {
    const element = this.element as HTMLElement
    const url: string | undefined = element.dataset.url

    if (typeof url !== 'string' || url.length === 0) return

    const a = document.createElement('a')
    a.href = url
    a.download = ''
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    a.remove()

    element.remove()
  }
}
